<script setup lang="ts">
const { $pwa } = useNuxtApp()

const isInstalling = ref<boolean>(false)

const { size } = defineProps<{
  size: 'xs' | 'sm' | 'md' | 'lg' | 'xl'
}>()

// Handles the installation
async function handleInstall() {
  isInstalling.value = true
  if (!$pwa) return
  await $pwa.install()
  if ($pwa.offlineReady) {
    isInstalling.value = false
  }
}
</script>

<template>
  <UButton
    v-if="$pwa?.showInstallPrompt"
    icon="i-heroicons-arrow-down-tray"
    :size="size"
    color="neutral"
    variant="outline"
    :loading="isInstalling"
    :label="$t('install')"
    @click="handleInstall"
  />
</template>
